
// Sources for the armpit pain and lymph nodes article
export const armpitPainLymphNodesSources = [
  {
    text: "Mayo Clinic: 'Swollen lymph nodes'",
    link: "https://www.mayoclinic.org/diseases-conditions/swollen-lymph-nodes/symptoms-causes/syc-20353902"
  },
  {
    text: "American Cancer Society: 'Lymph Nodes and Cancer'",
    link: "https://www.cancer.org/cancer/lymphoma/detection-diagnosis-staging/what-is-lymphoma.html"
  },
  {
    text: "National Cancer Institute: 'Lymph Nodes'",
    link: "https://www.cancer.gov/publications/dictionaries/cancer-terms/def/lymph-node"
  },
  {
    text: "Cleveland Clinic: 'Swollen Lymph Nodes'",
    link: "https://my.clevelandclinic.org/health/diseases/15219-swollen-lymph-nodes"
  }
];
